import { QboCustomerProperty, QboLinkResult } from "../../domain/quickbooks/quickbooksModel"
import LinkCustomerToQuickBooks from "../quickbooks/LinkCustomerToQuickBooks"
import { CustomerDetail } from "./customerApi"
import { useCustomerDetailInvalidator } from "./customerQueries"

type Props = {
  open: boolean
  customer: CustomerDetail | null
  onClose: () => void
  onLinked?: (result: QboLinkResult) => void
}

const toQboProperties = (customer: CustomerDetail | null): QboCustomerProperty[] =>
  (customer?.propertyList ?? []).map(p => ({ id: p.id, address1: p.address1 }))

// Adapts a CustomerDetail onto the shared React QuickBooks linking flow
// (push with multi-property selection / link / unlink), replacing the legacy
// jQuery link-qbo-entity + property-select modals.
const CustomerQuickBooksLink = ({ open, customer, onClose, onLinked }: Props) => {
  const { invalidateCustomer } = useCustomerDetailInvalidator()

  return <LinkCustomerToQuickBooks
    customerId={open && customer ? customer.id : undefined}
    customerDisplayName={customer?.displayName ?? ''}
    currentQboId={customer?.qboId ?? undefined}
    currentQboDisplayName={customer?.qboDisplayName ?? undefined}
    propertyList={toQboProperties(customer)}
    onSuccess={result => {
      if (customer) {
        invalidateCustomer(customer.id)
      }
      onLinked?.(result)
    }}
    onClose={onClose}
  />
}

export default CustomerQuickBooksLink
